module.exports = __webpack_public_path__ + "media/images/chart-6b50c84036ccb7217fb3835be813fec2.png";